export default class extends Phaser.Game {
  constructor(config, props) {
    super(config);
    this.props = props;
    // console.log('add props');
    const componentDidUpdate = new Phaser.Signal();
    componentDidUpdate.add(this.componentDidUpdate, this);
    this.signals = { componentDidUpdate };
  }

  destroy() {
    // console.log('destroy!');
    this.signals.componentDidUpdate.dispose();
    this.signals = null;
    this.props = null;
    super.destroy();
  }

  componentDidUpdate(nextProps) {
    const prevProps = { ...this.props };
    const currentState = this.state.getCurrentState();
    if (!currentState) return;

    const componentDidUpdate = currentState.componentDidUpdate;
    this.props = {
      ...this.props,
      ...nextProps,
    };
    if (componentDidUpdate) componentDidUpdate.call(currentState, prevProps);
  }
}
